import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate(['LIST_UNREADS', 'CLEAR_THREAD_UNREADS']);
export const AllClassesUnreadsKey = 'allClasses';
